import React from 'react';
import PropTypes from 'prop-types';
import { ToggleArrow } from 'web-store-modules/packages/web-store-ui-library';


const SizeSelectorItem = ({ text, onClick, showArrow, arrowDown, relative, style, checkStock }) => {
    const containerStyle = relative ? { position: relative } : {};
    const notInStockBackGround = checkStock === undefined || checkStock ? {} : { backgroundColor: '#E0E0E0' };
   
    return (
        <div style={{ ...containerStyle, ...style }, notInStockBackGround} className="size-selector-item pointer" onClick={onClick}>
            <p>{text === "Default Title" ? "One Size" : text}</p>
            <span>{showArrow && <ToggleArrow down={arrowDown} style={{ marginTop: '1em' }} />}</span>
        </div>
    );
}

SizeSelectorItem.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    relative: PropTypes.bool,
    showArrow: PropTypes.bool,
    arrowDown: PropTypes.bool,
    checkStock: PropTypes.func
};

SizeSelectorItem.defaultProps = {
    relative: false,
    showArrow: false
};

export default SizeSelectorItem;
